import { Environment } from "../../../environments/Environment";
import { axiosInstance as axios } from "../../interceptor/useAxiosInterceptors";

export const GetAllEvents = async (page = 0, size = 10) => {
    try {
        const response = await axios.get(`${Environment.emsUrl}/api/events/getAll`, {
            params: { page, size }
        });
        return response.data;
    } catch (error) {
        console.error("Error in GetAllEvents:", error);
        throw error;
    }
};

export const GetEventImages = async (eventId) => {
    try {
        const response = await axios.get(`${Environment.emsUrl}/api/events/${eventId}/images`);
        return response.data;
    } catch (error) {
        console.error("Error in GetEventImages:", error);
        throw error;
    }
};

export const CreateEvent = async (formData) => {
    try {
        const response = await axios.post(`${Environment.emsUrl}/api/events`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error in CreateEvent:", error);
        throw error;
    }
};

export const DeleteEvent = async (eventId) => {
    try {
        const response = await axios.delete(`${Environment.emsUrl}/api/events/${eventId}`);
        return response.data;
    } catch (error) {
        console.error("Error in DeleteEvent:", error);
        throw error;
    }
};
